import { render, staticRenderFns } from "./LicenseInfo.vue?vue&type=template&id=09ade912&scoped=true"
import script from "./LicenseInfo.vue?vue&type=script&lang=js"
export * from "./LicenseInfo.vue?vue&type=script&lang=js"
import style0 from "./LicenseInfo.vue?vue&type=style&index=0&id=09ade912&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ade912",
  null
  
)

export default component.exports